import React from "react"

class RoomTypeDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.code) {
      return (
        <ul style={{margin: 0, padding: 0}}><li style={{listStyleType: 'none'}}>{this.props.data.code}</li></ul>
      );
    } else {
      return null;
    }
  }

};

export default RoomTypeDataType
